import { render, staticRenderFns } from "./PointLog.vue?vue&type=template&id=4227a600&"
import script from "./PointLog.vue?vue&type=script&lang=js&"
export * from "./PointLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports